import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { CSearchSolutionCard, CSearchSolutionCardSkeleton, } from '@/components/modules/pages/consultantSearch/Card/CSearchSolutionCard';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
import { solutionOnePath } from '@/utils/router/links';
import { propArrayShape, propBool, propFunc, propShape, propNumber, } from '../../../../helpers/custom-prop-types';
import CustomSlider from '../../Slider';
const ConsultantSearchSolutionSlider = (props) => {
    const { config: rawConfig, fillCount: rawFillCount, isLg, isMd, isPre, showPreModal, solutionLoading, solutions, } = props;
    const config = useMemo(() => (Object.assign({ adaptiveHeight: true, arrows: true, infinite: solutions.length > 4, responsive: [
            {
                breakpoint: 1024,
                settings: {
                    infinite: solutions.length > 3,
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    infinite: solutions.length > 1,
                    slidesToShow: 1,
                    variableWidth: true,
                },
            },
        ], slidesToShow: 4, swipeToSlide: true }, rawConfig)), [rawConfig, solutions]);
    const fillCount = useMemo(() => {
        if (rawFillCount) {
            return rawFillCount;
        }
        let v = 4;
        if (isMd) {
            v = 1;
        }
        else if (isLg) {
            v = 3;
        }
        return v;
    }, [rawFillCount, isMd, isLg]);
    const dummies = useArrayWithIndex(fillCount);
    return (_jsx("div", Object.assign({ className: 'consultant-search-slider' }, { children: _jsx(CustomSlider, Object.assign({ config: config, fillCount: solutions.length >= fillCount ? 0 : fillCount - solutions.length }, { children: solutionLoading && solutions.length === 0
                ? dummies.map(({ index }) => (_jsx(CSearchSolutionCardSkeleton, {}, index)))
                : solutions.map((solution) => (_jsx(CSearchSolutionCard, { className: clsx('ui-solution-card', 'w-full'), image: solution.thumbnail, noLinkElement: isPre ? 'button' : undefined, onClickNoLink: showPreModal, period: solution.period, price: solution.price, target: '_blank', title: solution.title, to: solutionOnePath(solution.id) }, solution.id))) })) })));
};
ConsultantSearchSolutionSlider.propTypes = {
    config: propShape(),
    fillCount: propNumber(),
    isLg: propBool().isRequired,
    isMd: propBool().isRequired,
    isPre: propBool().isRequired,
    showPreModal: propFunc().isRequired,
    solutionLoading: propBool().isRequired,
    solutions: propArrayShape().isRequired,
};
ConsultantSearchSolutionSlider.defaultProps = {
    config: {},
    fillCount: undefined,
};
export default ConsultantSearchSolutionSlider;
